module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c56dfc57ba7eab324fed5cd72a0d92c9.png";